import { DashboardMenuOption } from 'components/dashboard-menu/constants'
import {RasaLogo} from 'components/icons/rasalogo'
import React, {Component} from 'react'
import * as ReactStrap from 'reactstrap'
import * as GlobalConstants from '../../constants'
import { loadPartnerConfiguration, applyPartnerConfig } from '../../app/utils'
import './styles.css'

const {Col, Row} = ReactStrap

interface Props {
  content: any,
  heading: string,
}

interface State {
  partnerConfig: any,
}

export class SuccessPageComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props, '');
    this.state = {
      partnerConfig: null,
    }
  }

  public componentDidMount() {
    loadPartnerConfiguration()
      .then((config) => {
        this.setState({ partnerConfig: config })
        applyPartnerConfig(config)
      })
  }

  public render() {
    return (
      <div className="success-page">
        <div className="dashboard-menu">
          <div className={'dashboard-menu-item dashboard-rasa-logo'}
            onClick={() => this.handleClick(DashboardMenuOption.dashboard)}>
            {this.renderLogo()}
          </div>
          <div className="help-links-container">
            <div className="dashboard-popup-menu-item clickable-item need-a-help">
              <a href={this.state.partnerConfig && this.state.partnerConfig.HELP_URL ? this.state.partnerConfig.HELP_URL : GlobalConstants.RASA_HELP_BASE_URL} target="_blank" rel="noopener">Help & Support</a>
            </div>
          </div>
        </div>
        <Row className="success-page-wrapper">
          <Col md="6" lg="12" className="content">
            <h1>{this.props.heading || 'Success'}</h1>
            <p className="enter-paragraph">{this.props.content}</p>
          </Col>
        </Row>
      </div>
    )
  }

  private handleClick(item: DashboardMenuOption) {
    window.location.replace(item)
  }

  private renderLogo(): JSX.Element {
    if (this.state.partnerConfig === null) {
      return null // wait until partnerConfig is loaded
    }

    if (this.state.partnerConfig && this.state.partnerConfig.WHITELABEL_LOGO_URL) {
      return <img src={this.state.partnerConfig.WHITELABEL_LOGO_URL} width="80" height="17.068"/>
    } else {
      return <RasaLogo/>
    }
  }
}
